import React, { useEffect, useState } from "react";
import "./CupCakeForm.css";
import { toast } from "react-toastify";
import { SyncOutlined } from "@ant-design/icons";
import { Modal } from "antd";
// import axios from "axios";
import { axiosInstance } from "../../config";
function CupCakeForm() {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  //define orders
  const [order, setOrder] = useState({
    name: "",
    contact: "",
    flavour: "",
    price: 0,
    numberOfOrders: 1,
    delivery: "",
    total: 0,
  });

  //calculate total price
  // const price = order.price;
  // const orderNumber = order.numberOfOrders;
  const [finalPrice, setFinalPrice] = useState(0);
  useEffect(() => {
    setFinalPrice(() => order.price * order.numberOfOrders);
  }, [order.flavour, order.numberOfOrders, order.price]);
  //to display amount immediately to users
  const amountToPay = finalPrice;

  //define flavours
  const flavours = [
    { flavour: "Chocolate", quantity: 4, price: 42 },
    { flavour: "Red velvet", quantity: 6, price: 58 },
    { flavour: "Lemon", quantity: 12, price: 110 },
    { flavour: "Vanilla", quantity: 15, price: 145 },
  ];
  //

  const handleChange = (e) => {
    setOrder({ ...order, [e.target.name]: e.target.value });
  };
  //
  const HandleSelect = (e) => {
    setOrder({
      ...order,
      flavour: e.target.options[e.target.selectedIndex].text,
      price: e.target.value,
    });
  };

  console.log(order);
  console.log(finalPrice);
  //
  const OnSubmit = async (e) => {
    try {
      e.preventDefault();
      setOrder({
        ...order,
        total: finalPrice,
      });
      const { data } = await axiosInstance.post(`/api/cupcake`, {
        name: order.name,
        contact: order.contact,
        flavour: order.flavour,
        numberOfOrders: order.numberOfOrders,
        delivery: order.delivery,
        price: finalPrice,
      });
      toast.success("Order Placed. Screenshot pop-up for payment details");
      setVisible(true);
      setLoading(false);
      console.log(data);
      console.log("Order Complete", order);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data);
      return err;
    }
  };

  return (
    <>
      {/* <h2 className="f-heading">Price List For One Order of CupCake </h2> */}
      <div className="cup-cakeForm">
        <div className="Flavour">
          <h1 className="f-heading">Flavour</h1>
          {flavours.map((list, index) => (
            <h1 key={index} className="list">
              {list.flavour}
            </h1>
          ))}
        </div>
        <div className="Flavour">
          <h1 className="f-heading">Quantity Per An Order</h1>
          {flavours.map((list) => (
            <h1 className="list">{list.quantity}</h1>
          ))}
        </div>
        <div className="Flavour">
          <h1 className="f-heading">Price</h1>
          {flavours.map((list, index) => (
            <h1 key={index} className="list">
              {list.price + " GHC"}
            </h1>
          ))}
        </div>
      </div>
      <form action="" onSubmit={OnSubmit}>
        <div className="order-info">
          <div>
            <input
              className="order-input"
              name="name"
              type="text"
              placeholder="Name"
              onChange={handleChange}
            />
          </div>
          <div>
            <input
              className="order-input"
              name="contact"
              type="tel"
              placeholder="Contact"
              onChange={handleChange}
            />
          </div>
          <select className="select" onChange={HandleSelect} required>
            <option value="none">-- Flavour --</option>
            {flavours.map((flavour, index) => (
              <option key={index} name={flavour.flavour} value={flavour.price}>
                {flavour.flavour}
              </option>
            ))}
          </select>
          <input
            className="order-input"
            name="numberOfOrders"
            type="number"
            min="1"
            max="20"
            placeholder="1 Order"
            onChange={handleChange}
          />
          <div
            className="
        note"
          >
            <h1>
              <em>
                Delivery Cost will be charged by the rider,
                <br />
                make sure to contact us with your order details and the location
                you want the order delivered to via whatsapp or call
              </em>
            </h1>
          </div>
          <select
            className="select"
            name="delivery"
            onChange={handleChange}
            required
          >
            <option value="">-- Delivery Method --</option>
            <option value="Pickup">Pick Up</option>
            <option value="Delivery">Delivery</option>
          </select>

          <div className="price">
            <h1 className="price-text-main">
              <span className="price-text"> Total Amount:</span>
              {" " + amountToPay + " "}
              <span className="price-text"> GHC </span>
            </h1>
          </div>
        </div>
        <button
          onClick={OnSubmit}
          disabled={!order.name || !order.contact || loading}
        >
          {loading ? <SyncOutlined spin /> : "Order"}
        </button>
      </form>
      <Modal
        title="PAYMENT DETAILS"
        centered
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
      >
        {/* order
        <pre>{JSON.stringify(order, null, 5)}</pre> */}
        <div className="modal-main">
          <div className="modal-details">
            <h3 className="m-heading1">Please Screenshot Oder Details</h3>
            <h3 className="m-heading">Oder Details</h3>
            <div className="m-details">
              <h1 className="m-label">Name: </h1>
              <h1 className="m-details">{order.name}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Contact: </h1>
              <h1 className="m-details">{order.contact}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Flavour: </h1>
              <h1 className="m-details">{order.flavour}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Order(s): </h1>
              <h1 className="m-details">{order.numberOfOrders}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Delivery Method: </h1>
              <h1 className="m-details">{order.delivery}</h1>
            </div>
            <div className="m-details">
              <h1 className="m-label">Total: </h1>
              <h1 className="m-details">{order.total + " GHC"}</h1>
            </div>
          </div>
          <div className="modal-payment">
            <h1 className="m-label">
              Make payment of {order.total + " GHC"} to{" "}
              <span className="m-number">0553009397 or 0509034660</span>{" "}
            </h1>
            <h1>
              Use your <span className="m-number">Name</span> or{" "}
              <span className="m-number"> Number</span> as Reference
            </h1>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default CupCakeForm;
